import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { refundCompleteReturn } from "../../api/apiReturns";
import parseError from "../../utils/parseError";

export const useRefundCompleteReturn = () => {
    const queryClient = useQueryClient();

    const { mutate: refundCompleteReturnMutate, isPending: isRefundCompleting } = useMutation({
        mutationFn: ({ id, data }) => refundCompleteReturn(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Refund marked as complete");
            queryClient.invalidateQueries(["returns"]);
            queryClient.invalidateQueries(["return"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to mark refund as complete");
        },
    });

    return { refundCompleteReturnMutate, isRefundCompleting };
};
